import React from 'react';

import TextField from '../../audi-ui-components/TextField';
import Select from '../../audi-ui-components/Select';
import RadioFieldset from '../../audi-ui-components/RadioFieldset';

import {
    FIELD_SELECT,
    FIELD_TEXT,
    FIELD_RADIO,
} from '../../constants';

const fieldComponents = {
    [FIELD_SELECT]: Select,
    [FIELD_TEXT]: TextField,
    [FIELD_RADIO]: RadioFieldset,
};

const FormField = (props) => {

    const {fieldType, name, formikBag, onChange, formatValue, wrapperClassName, showErrors, theme, ...rest} = props;
    const {values, errors, touched, submitCount, setFieldValue, setFieldTouched} = formikBag;

    // allow errors to be a string or array
    let errMsg = "";
    if (errors[name]) {
        if (typeof errors[name] === 'string') {
            errMsg = errors[name];
        } else if (Array.isArray(errors[name])) {
            errMsg = errors[name][0];
        }
    }

    const Component = fieldComponents[fieldType];
    return (
        <div className={`form-field ${wrapperClassName}`}>
            <Component
                name={name}
                value={values[name] || ""}
                theme={theme === "dark" ? "light" : null}
                onBlur={() => { setFieldTouched(name); }}
                onChange={(v) => {
                    if (typeof formatValue === 'function') {
                        v = formatValue(v);
                    } else if (name === "addressPostcode" || name === "emailAddress") {
                        v = v.trim();
                    }
                    setFieldValue(name, v);
                    onChange(v);
                }}
                isInvalid={Boolean(errors[name] && (touched[name] || submitCount > 0 || showErrors))}
                invalidMessage={errMsg}
                {...rest}
            />
        </div>
    );
}

FormField.defaultProps = {
    onChange: () => {},
    wrapperClassName: "mb-4",
    fieldType: FIELD_TEXT
}

export default FormField;
